<template>
  <div class="">
    <vs-popup
      type="filled"
      pazaryer
      title="Cari Ekstre"
      :active.sync="popupKartDetay"
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <b-card-text> Cari Adı: {{ ACTNAME }} </b-card-text>
            <vs-divider color="Default"> </vs-divider>
            <b-row>
              <b-col lg="1" sm="12">
                <label for="datepicker-sm">Tarih: </label></b-col
              >
              <b-col lg="3" sm="5">
                <b-form-datepicker
                  id="datepickerbaslangic"
                  v-model="datepickerbaslangic"
                  size="sm"
                  local="en"
                  class="mb-2"
                  today-variant="danger"
                  placeholder="-"
                  :start-weekday="weekday"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                  }"
                />
              </b-col>
              <b-col lg="3" sm="5">
                <b-form-datepicker
                  id="datepickerbitis"
                  v-model="datepickerbitis"
                  placeholder="-"
                  size="sm"
                  local="en"
                  class="mb-2"
                  today-variant="danger"
                  :start-weekday="weekday"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                  }"
                />
              </b-col>

              <b-col lg="2" sm="5">
                <b-form-input
                  v-model="faizOran"
                  id="smallInput"
                  size="sm"
                  placeholder="Faiz Oranı"
                />
              </b-col>
              <b-col lg="2" sm="5">
                <ButtonPrimary
                  :title="title"
                  :size="size"
                  @test-click="listele"
                />
              </b-col>
            </b-row>
            <vs-divider color="Default"> </vs-divider>
            <vs-tabs style="height: 450px" alignment="fixed">
              <vs-tab label="Genel Durum">
                <div>
                  <b-card-text>
                    <ExcelYazdirComponent :excelData="cariEkstreList" />
                    <vue-good-table
                      :columns="cariEkstreListcolumns"
                      :rows="cariEkstreList"
                      :rtl="dir"
                      max-height="250px"
                      :fixed-header="true"
                      :row-style-class="rowStyleClassFn"
                    >
                      <template slot="table-row" slot-scope="props">
                        <!-- Column: Name -->
                        <div
                          v-if="props.column.field === 'TRANSDATE'"
                          class="text-nowrap"
                        >
                          <span class="text-nowrap">{{
                            props.row.TRANSDATE
                          }}</span>
                        </div>
                      </template>

                      <!-- pagination -->
                    </vue-good-table>
                  </b-card-text>
                </div>
              </vs-tab>
              <vs-tab active @click="hareketTuruList" label="Hareket Türü">
                <div>
                  <ExcelYazdirComponent :excelData="hareketTuruListesi" />
                  <vue-good-table
                    :columns="hareketTuruListesicolumns"
                    :rows="hareketTuruListesi"
                    :rtl="dir"
                    max-height="250px"
                    :fixed-header="true"
                    :row-style-class="rowStyleClassFn"
                  >
                    <template slot="table-row" slot-scope="props">
                      <!-- Column: Name -->
                      <div
                        v-if="props.column.field === 'TRANSDATE'"
                        class="text-nowrap"
                      >
                        <span class="text-nowrap">{{
                          props.row.TRANSDATE
                        }}</span>
                      </div>
                    </template>

                    <!-- pagination -->
                  </vue-good-table>
                </div>
              </vs-tab>
              <vs-tab @click="stokHareketList" label="Stok Hareketleri">
                <div>
                  <ExcelYazdirComponent :excelData="stokHareketListesi" />
                  <vue-good-table
                    :columns="stokHareketListesicolumns"
                    :rows="stokHareketListesi"
                    :rtl="dir"
                    max-height="250px"
                    :fixed-header="true"
                    :row-style-class="rowStyleClassFn"
                  >
                    <template slot="table-row" slot-scope="props">
                      <!-- Column: Name -->
                      <div
                        v-if="props.column.field === 'TRANSDATE'"
                        class="text-nowrap"
                      >
                        <span class="text-nowrap">{{
                          props.row.TRANSDATE
                        }}</span>
                      </div>
                    </template>

                    <!-- pagination -->
                  </vue-good-table>
                </div>
              </vs-tab>
              <vs-tab @click="cariHareketlerList" label="Cari Hareketleri">
                <div>
                  <ExcelYazdirComponent :excelData="cariHareketlerListesi" />
                  <vue-good-table
                    :columns="cariHareketlerListesicolumns"
                    :rows="cariHareketlerListesi"
                    :rtl="dir"
                    max-height="250px"
                    :fixed-header="true"
                    :row-style-class="rowStyleClassFn"
                  >
                    <template slot="table-row" slot-scope="props">
                      <!-- Column: Name -->
                      <div
                        v-if="props.column.field === 'ISLEMTURU'"
                        class="text-nowrap"
                      >
                        <span class="text-nowrap">{{
                          props.row.ISLEMTURU
                        }}</span>
                      </div>
                    </template>

                    <!-- pagination -->
                  </vue-good-table>
                </div>
              </vs-tab>
              <vs-tab @click="bakiyeYaslandırma()" label="Bakiye Yaşlandırma">
                <div>
                  <ExcelYazdirComponent :excelData="bakiyeYaslandırmaListesi" />

                  <vs-table
                    max-items="5"
                    pagination
                    stripe
                    :data="bakiyeYaslandırmaListesi"
                    :fixed-header="true"
                    :row-style-class="rowStyleClassFn"
                  >
                    <template slot="thead">
                      <vs-th sort-key="TRANSDATE">İşlem</vs-th>
                      <vs-th sort-key="BORC">İşlem No</vs-th>
                      <vs-th sort-key="ALACAK">Açıklama</vs-th>
                      <vs-th sort-key="BAKIYE">Tarih</vs-th>
                      <vs-th sort-key="BTip">Vade</vs-th>
                      <vs-th sort-key="BTip">Vade Farkı Tarih</vs-th>
                      <vs-th sort-key="BTip">Gün</vs-th>
                      <vs-th sort-key="BTip">Tutar</vs-th>
                      <vs-th sort-key="BTip">Toplam Tutar</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        state=""
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td>
                          {{ data[indextr].TRANSDATE }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].BORC }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].ALACAK }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].BAKIYE }}
                        </vs-td>
                        <vs-td>
                          {{ data[indextr].BTip }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BFormDatepicker,
  BTabs,
  BTab,
  BCardText
} from "bootstrap-vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import ButtonPrimary from "../global-components/ButtonPrimary.vue";

import moment from "moment";
import ExcelYazdirComponent from "../ExcelYazdirComponent.vue";
export default {
  components: {
    ButtonPrimary,
    ExcelYazdirComponent,
    BFormDatepicker,
    BButton,
    BModal,
    BTabs,
    BTab,
    BCardText
  },

  directives: {
    "b-modal": VBModal
  },
  data() {
    return {
      weekday:1,
      size: "small",
      title: "Listele",
      faizOran: "",
      cariEkstreList: [],
      hareketTuruListesi: [],
      stokHareketListesi: [],
      bakiyeYaslandırmaListesi: [],
      cariHareketlerListesi: [],
      excelYadirData: [],
      cariEkstreListcolumns: [
        {
          label: "Döviz",
          field: "CURRCODE"
        },
        {
          label: "Borç",
          field: "BORC"
        },
        {
          label: "Alacak",
          field: "ALACAK"
        },
        {
          label: "Bakiye",
          field: "BAKIYE"
        },
        {
          label: "Bakiye Adı",
          field: "BTip"
        }
      ],
      hareketTuruListesicolumns: [
        {
          label: "Hareket Tipi",
          field: "TRANSTYPENAME"
        },
        {
          label: "Borç",
          field: "BORC"
        },
        {
          label: "Alacak",
          field: "ALACAK"
        },
        {
          label: "Bakiye",
          field: "BAKIYE"
        },
        {
          label: "Bakiye Tipi",
          field: "BTip"
        }
      ],
      cariHareketlerListesicolumns: [
        {
          label: "İşlem",
          field: "ISLEMTURU"
        },
        {
          label: "Belge No",
          field: "FISNO"
        },

        {
          label: "Tarih",
          field: "TRANSDATE"
        },
        {
          label: "Vade",
          field: "VADE"
        },
        {
          label: "Açıklama",
          field: "DESCRIPTION"
        },
        {
          label: "Borç",
          field: "BORC"
        },
        {
          label: "Alacak",
          field: "ALACAK"
        },
        {
          label: "Bakiye",
          field: "ROOTRECEIPTNO"
        },
        {
          label: "Bakiye Tipi",
          field: "BakTip"
        }
      ],
      stokHareketListesicolumns: [
        {
          label: "Tarih",
          field: "TRANSDATE"
        },
        {
          label: "Fiş No",
          field: "ROOTRECEIPTNO"
        },
        {
          label: "İşlem",
          field: "TRANSTYPENAME"
        },
        {
          label: "Stok Adı",
          field: "STOCKNAME"
        },
        {
          label: "Açıklama",
          field: "DESCRIPTION"
        },
        {
          label: "Giriş",
          field: "QENTRY"
        },
        {
          label: "Çıkış",
          field: "QEXIT"
        },
        {
          label: "Fiyat",
          field: "PRICE"
        }
      ],
      ACTNAME: "",
      datepickerbaslangic: "",
      datepickerbitis: "",
      ACTID: "",
      popupKartDetay: false,
      dir: false
    };
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    listele() {
      this.stokHareketList();
      this.cariHareketlerList();
    },
    formatDate(tarih) {
      return moment(String(tarih)).format("DD.MM.YYYY");
    },
    cariHareketlerList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var baslangic = moment(String(this.datepickerbaslangic)).format(
        "DD.MM.YYYY"
      );
      var bitis = moment(String(this.datepickerbitis)).format("DD.MM.YYYY");
      //ay.gün.yıl
      const args = {
        token: Store.state.tokenId,
        ACTID: this.ACTID,
        ILKTARIH: baslangic,
        SONTARIH: bitis
      };
      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_CARIHAREKET(args, function(err, result) {
          if (result.INT_ACTEKS_CARIHAREKETResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_ACTEKS_CARIHAREKETResult);
          vm.cariHareketlerListesi = vm.veriler;
          // vm.rows = vm.veriler;
        });
      });
    },
    bakiyeYaslandırma() {
      //  alert("bakiyeYaslandırma");
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var baslangic = moment(String(this.datepickerbaslangic)).format(
        "DD.MM.YYYY"
      );
      var bitis = moment(String(this.datepickerbitis)).format("DD.MM.YYYY");
      //ay.gün.yıl
      const args = {
        token: Store.state.tokenId,
        ACTID: this.ACTID,
        ILKTARIH: baslangic,
        SONTARIH: bitis
      };
      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_BAKIYEYASLANDIRMA(args, function(err, result) {
          if (result.INT_ACTEKS_BAKIYEYASLANDIRMAResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_ACTEKS_BAKIYEYASLANDIRMAResult);
        });
      });
      //  this.datepickerbaslangic = "";
      //  this.datepickerbitis = "";
    },
    stokHareketList() {
      // alert("stokHareketList");
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var baslangic = moment(String(this.datepickerbaslangic)).format(
        "DD.MM.YYYY"
      );
      var bitis = moment(String(this.datepickerbitis)).format("DD.MM.YYYY");
      //ay.gün.yıl
      const args = {
        token: Store.state.tokenId,
        ACTID: this.ACTID,
        ILKTARIH: baslangic,
        SONTARIH: bitis
      };
      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_STOKHAREKET(args, function(err, result) {
          if (result.INT_ACTEKS_STOKHAREKETResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_ACTEKS_STOKHAREKETResult);
          vm.stokHareketListesi = vm.veriler;
          vm.excelYadirData = vm.stokHareketListesi;
          // vm.rows = vm.veriler;
        });
      });
    },
    hareketTuruList() {
      //  alert("in");
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: this.ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_HAREKETTURU(args, function(err, result) {
          if (result.INT_ACTEKS_HAREKETTURUResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_ACTEKS_HAREKETTURUResult);
          vm.hareketTuruListesi = vm.veriler;
        });
      });
    },
    cariEkstre(ACTID, ACTNAME) {
      // alert(ACTNAME);
      //this.$refs["modalCariEkstre"].show();
      this.ACTID = ACTID;
      this.ACTNAME = ACTNAME;
      this.popupKartDetay = true;

      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ACTID: ACTID
      };
      soap.createClient(url, function(err, client) {
        client.INT_ACTEKS_GENEL(args, function(err, result) {
          if (result.INT_ACTEKS_GENELResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.INT_ACTEKS_GENELResult);
          vm.cariEkstreList = vm.veriler;
        });
      });
    },
    direction() {
      this.dir = false;
      return this.dir;
    }
  }
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 900px;
}
.VGT-row:hover {
  background-color: rgb(187, 185, 185);
}
</style>
